import { ScientificAnalysisConditionComponent, ScientificAnalysisStaticImplements } from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel/scientific-analysis-filter-panel-conditionfactory'
import { ScientificAnalysisComparatorType, ScientificAnalysisConditionTypeEnum } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'
import { ScientificAnalysisComparisonType, ScientificAnalysisCondition, ScientificAnalysisConditionValidationErrorCode } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component({
    components: {}
})
// eslint-disable-next-line no-use-before-define
@ScientificAnalysisStaticImplements<ScientificAnalysisConditionComponent<ScientificAnalysisFilterPanelFreetext>>()
export default class ScientificAnalysisFilterPanelFreetext extends Vue {
    static VALIDATION_EMPTY_CODE = 1
    static COMPONENT_NAME = 'scientific-analysis-filter-panel-freetext'
    static ALLOWED_COMPARATORS: ScientificAnalysisComparatorType[] = [
        ScientificAnalysisComparatorType.CONTAINS,
        ScientificAnalysisComparatorType.ENDS_WITH,
        ScientificAnalysisComparatorType.EQUALS,
        ScientificAnalysisComparatorType.NOT_CONTAINS,
        ScientificAnalysisComparatorType.NOT_EQUAL,
        ScientificAnalysisComparatorType.STARTS_WITH
    ]
    @Prop() condition!: ScientificAnalysisCondition

    static canAccept(comparisonType: ScientificAnalysisComparisonType): boolean {
        return (!comparisonType.additionalInfo || comparisonType.additionalInfo === null || comparisonType.additionalInfo.length === 0) &&
            ScientificAnalysisFilterPanelFreetext.ALLOWED_COMPARATORS.includes(comparisonType.comparatorType) &&
            (comparisonType.conditionType === ScientificAnalysisConditionTypeEnum.NUMBER ||
                comparisonType.conditionType === ScientificAnalysisConditionTypeEnum.TEXT)
    }

    get _validate(): boolean {
        if (this.condition.value.length === 0) {
            this.condition.validationErrorCode = ScientificAnalysisConditionValidationErrorCode.EMPTY
        } else {
            this.condition.validationErrorCode = ScientificAnalysisConditionValidationErrorCode.NONE
        }
        return this.condition.validationErrorCode !== ScientificAnalysisConditionValidationErrorCode.NONE
    }

    @Emit('modification')
    _onChange() { }
}
